/**
 * @generated SignedSource<<9c363b65a4dab7fd5729ea9057b52c65>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssetStatusEnumType = "errored" | "preparing" | "ready" | "%future added value";
export type VimeoVideoStatus = "available" | "generic_error" | "not_found" | "not_found_error" | "quota_exceeded" | "transcode_starting" | "transcoding" | "transcoding_error" | "uploading" | "uploading_error" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useShowVimeoVideo_item$data = {
  readonly videoMux: {
    readonly playbackId: string | null;
    readonly status: AssetStatusEnumType | null;
  } | null;
  readonly videoVimeo: {
    readonly status: VimeoVideoStatus | null;
    readonly vimeoId: string | null;
  } | null;
  readonly " $fragmentType": "useShowVimeoVideo_item";
};
export type useShowVimeoVideo_item$key = {
  readonly " $data"?: useShowVimeoVideo_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowVimeoVideo_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "convertToVimeoFormat",
          "value": false
        }
      ],
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "videoVimeo",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vimeoId",
          "storageKey": null
        }
      ],
      "storageKey": "videoVimeo(convertToVimeoFormat:false)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoV2",
      "kind": "LinkedField",
      "name": "videoMux",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "playbackId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "a2908f5730d1dcd516f6daa1528f7bae";

export default node;
